import { MessagePreview } from '@tribeplatform/gql-client/types'

import { Image } from '../../../common/components/Image.js'

interface Props {
  previewMessage: MessagePreview
}

export const ImageAttachmentPreview = ({ previewMessage }: Props) => {
  const { imagePreview } = previewMessage

  if (!imagePreview) {
    return null
  }

  return (
    <Image
      src={imagePreview?.iconUrl}
      alt={imagePreview?.name}
      className="w-5 rounded-xs"
    />
  )
}
